<template>
	<div class="bread">
		<a href="javascript:;">当前位置: </a>
		<router-link to="/">首页</router-link>
		<router-link :to="currentPage.path"> > {{currentPage.name}}</router-link>
		<router-link v-if="currentPage.childPath" :to="currentPage.childPath"> > {{currentPage.childName}}</router-link>
		
	</div>
</template>

<script>
	export default {
		props:['currentPage']
	}
</script>

<style lang="scss">
	@include component(bread){
		width: 1200px;
		height: 100%;
		margin: 0 auto;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		color: #999999;
		a{
			color: #999999;
			font-size: 16px;
			display: inline-block;
			margin-right: 5px;
		}
	}
</style>
